import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import React from 'react';
import '../../../../stylesheets/components/phone_input.scss';

interface PhoneVerificationStatusIconProps {
  disabled?: boolean;
  onClick?: () => void;
  size?: 'default' | 'small';
  verified: boolean;
}

/**
 * Renders the shared verified/unverified phone badge. It can be a compact,
 * informational status or an accessible button that resumes verification.
 */
const PhoneVerificationStatusIcon: React.FC<PhoneVerificationStatusIconProps> = ({
  disabled = false,
  onClick,
  size = 'default',
  verified,
}) => {
  let tooltip = 'Number not verified';
  if (verified) {
    tooltip = 'Number verified';
  } else if (onClick) {
    tooltip = 'Verification incomplete. Click to continue.';
  }
  const className = [
    'phone-verification-badge',
    `phone-verification-badge--${verified ? 'verified' : 'unverified'}`,
    size === 'small' ? 'phone-verification-badge--small' : '',
  ].filter(Boolean).join(' ');
  const icon = verified ? <CheckRoundedIcon /> : <CloseRoundedIcon />;

  if (onClick) {
    return (
      <Tooltip title={tooltip} enterTouchDelay={0}>
        <IconButton
          className={className}
          aria-label="Verify phone number"
          disabled={disabled}
          onClick={onClick}
        >
          {icon}
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={tooltip} enterTouchDelay={0}>
      <span className={className} aria-label={tooltip}>
        {icon}
      </span>
    </Tooltip>
  );
};

export { PhoneVerificationStatusIcon };
